import { atom } from 'recoil';

export const productSortState = atom<string>({
  key: 'productSortState',
  default: ''
});
